export default "__VITE_PUBLIC_ASSET__8a9982fd__"